import { Space, Typography, Row, Col } from "antd";
import { FC, useEffect } from 'react';
import { MailOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import styles from '../index.module.less';
import ResendVerificationEmailButton from './ResendVerificationEmailButton';
import { getDataInStorage } from '../../../../utils/storage';

const EmailVerificationPage: FC = () => {
  const navigate = useNavigate();
  const auth = getDataInStorage('auth');

  const isEmailVerified = auth?.user?.isEmailVerified;
  const userEmail = auth?.email || auth?.user?.email;

  useEffect(() => {
    if (isEmailVerified) {
      navigate("/", { replace: true });

      return;
    }

    if (!userEmail) {
      navigate('/sign-in', { replace: true });
    }
  }, []);

  return (
    <Space direction="vertical" size={24} className={styles.formContainer} style={{ padding: '0 12px' }}>
      <div style={{ textAlign: 'center' }}>
        <MailOutlined style={{ fontSize: 64, color: '#1E0C68', marginBottom: 24 }} />
        <Typography.Title level={2} style={{ marginBottom: 8, color: '#464646' }}>
          Verify Your Email
        </Typography.Title>
      </div>

      <Typography.Paragraph style={{ textAlign: 'center' }}>
        We've sent a verification link to <strong>{auth?.email}</strong>.
        Please check your inbox and click the link to activate your account.
      </Typography.Paragraph>

      <Typography.Paragraph type="secondary" style={{ textAlign: 'center' }}>
        Didn't receive the email? Check your spam folder or resend the verification email.
      </Typography.Paragraph>

      <Row gutter={24}>
        <Col span={24}>
          <ResendVerificationEmailButton userEmail={userEmail} />
        </Col>
      </Row>

      <div className={styles.textBox}>
        <Typography.Text className={styles.text}>
          Already verified?{' '}
          <Link to="/sign-in" style={{ color: '#1E0C68', cursor: 'pointer' }}>
            Sign In
          </Link>
        </Typography.Text>
      </div>
    </Space>
  );
};

export default EmailVerificationPage;
